<template>
  <el-popover placement="top-start" width="300" trigger="hover">
    <div class="message-box-content">
      <div class="message-box-title">
        <div class="message-box-title-lable">消息中心</div>
        <div class="message-box-title-links">
          <span><router-link to="/message">更多消息</router-link></span>
        </div>
      </div>
      <div class="message-box-msg">
        <ul v-if="messageData.length > 0" class="message-box-message-items">
          <li v-for="item in messageData" :key="item.id">
            <!-- <a class="message-box-message-item">
              <span class="message-box-message-text">{{ item.title }}</span>
              <span class="message-box-message-time">{{ item.sendTime }}</span>
            </a> -->
            <router-link :to="'/message/'+ item.id" class="message-box-message-item">
              <span class="message-box-message-text">{{ item.title }}</span>
              <span class="message-box-message-time">{{ item.sendTime }}</span>
            </router-link>
          </li>
        </ul>
        <el-empty v-else :image-size="120" description="暂无新消息"></el-empty>
      </div>
      <div class="message-box-more"></div>
    </div>

    <el-badge
      slot="reference"
      :hidden="!total > 0"
      :value="total"
      class="item"
    >
      <i class="el-icon-bell" style="font-size: 20px" />
    </el-badge>
  </el-popover>
</template>

<script>
import { myMessageService } from "@/api/messages";

export default {
  data() {
    return {
      messageData: [],
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取消息列表
    getList() {
      myMessageService
        .getMyMessagePageList({
          // title: this.listQuery.keywords,
          state: '1',
          skipCount: 0,
          maxResultCount: 10,
        })
        .then((res) => {
          this.messageData = res.items;
          this.total = res.totalCount;
        });
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}

.message-box-content {
}
.message-box-title {
  flex-shrink: 0;
  /* border-bottom: 1px solid hsla(0, 0%, 100%, 0.1); */
  border-bottom: 1px solid #e4e4e4;
  padding: 6px 0 calc(4px * 4) 0;
  overflow: hidden;
  margin: 0 16px 8px 16px;
}

.message-box-title-lable {
  float: left;
  margin: 0;
  font-size: 16px;
  /* color: #181818; */
  font-weight: 600;
  padding-top: 10px;
  /* color: hsla(0,0%,100%,0.8); */
}

.message-box-title-links {
  float: right;
  line-height: 20px;
  padding: 10px 0 0 10px;
}

.message-box-title-links span {
  display: flex;
  align-items: center;
  position: relative;
}

.message-box-msg {
  height: 340px;
  position: relative;

  overflow-y: auto;
}

.message-box-message-items {
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
}
.message-box-message-items::-webkit-scrollbar {
  display: none;
}
.message-box-message-items .message-box-message-item {
  position: relative;
  display: block;
  overflow: hidden;
  width: 100%;
  line-height: 19.5px;
  text-decoration: none;
  padding: 12px 16px;
}

.message-box-message-text {
  float: left;
  width: 100%;
  word-break: break-all;
  word-wrap: normal;
  margin-bottom: 4px;
  font-size: 14px;
  /* color:hsla(0,0%,100%,0.8); */
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-box-message-time {
  font-size: 12px;
  color: #8a8e99;
}
.message-box-message-items .message-box-message-item:hover {
  background: #e4e4e4;
  text-decoration: none;
}
/* .message-box-message-items .message-box-message-item:hover .message-box-message-text {
  text-decoration:none;
  color:#fff
} */
</style>